module.exports = __webpack_public_path__ + "img/free.9dfdd00b.jpg";